import Reassurance from './Reassurance.vue'

export default Reassurance
